import tw from "twin.macro"

export const DecorativeImageWrapper = tw.div`relative all-child:(absolute inset-0 w-full h-full object-cover object-center)`
